import { appApi } from '~/redux/api/appApiSlice';
import {
  WalletTopupResponseType,
  WalletTransactionsType,
} from '~/types/walletTypes';

export const walletApiSlice = appApi.injectEndpoints({
  endpoints: (builder) => ({
    getTransactions: builder.query<
      WalletTransactionsType,
      {
        locale?: string;
        params?: string;
      }
    >({
      query: ({ locale, params }) => {
        return {
          url: `/api/v4/wallet/transactions?${params}`,
          headers: {
            'Accept-Language': locale,
          },
        };
      },
    }),
    getWalletTopup: builder.query<
      WalletTopupResponseType,
      { id: string; locale: string }
    >({
      query: ({ id, locale }) => {
        return {
          url: `/api/v4/top-up/${id}`,
          headers: {
            'Accept-Language': locale,
          },
        };
      },
    }),
  }),
});

export const {
  useLazyGetTransactionsQuery,
  useGetTransactionsQuery,
  useGetWalletTopupQuery,
} = walletApiSlice;
